import { Badge } from "../../ui/Badge";

interface ActiveStatusBadgeProps {
  isActive: boolean;
}

export function ActiveStatusBadge({ isActive }: ActiveStatusBadgeProps) {
  return (
    <Badge variant={isActive ? "default" : "secondary"}>
      {isActive ? "Active" : "Inactive"}
    </Badge>
  );
}
